import { Component, OnInit } from '@angular/core';
import { CategoriesService } from '../../../services/categories.service';
import { ApiListService } from '../../../../home/discover-api/api-list/api-list.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html'
})
export class SearchComponent implements OnInit {

  public searchText: string;
  constructor(
    public apiListService: ApiListService
  ) {
    this.searchText = '';
  }

  ngOnInit() {
  }

  public loadApi() {
    this.apiListService.changeSearchText(this.searchText);
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/modules/header/search/search.component.ts